import { render } from "./mmanage.vue?vue&type=template&id=6f1d0b52&scoped=true"
const script = {}

import "./mmanage.vue?vue&type=style&index=0&id=6f1d0b52&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1d0b52"]])

export default __exports__